import { useEffect } from "react";

import { setPageStatusBarStyle } from "~/utils/events";

import { QuizViewHeader } from "./QuizViewHeader";
import { QuizViewHeaderGroup } from "./QuizViewHeaderGroup";
import { QuizViewMenu } from "./QuizViewMenu";
import { QuizViewBody } from "./QuizViewBody";
import { QuizViewFooter } from "./QuizViewFooter";
import { QuizViewQuestion } from "./QuizViewQuestion";
import { QuizViewMessages } from "./QuizViewMessages";

import "./QuizView.css";

import type { ReactNode } from "react";

export interface QuizViewProps {
  children?: ReactNode;
}

export function QuizView({ children }: QuizViewProps) {
  useEffect(() => setPageStatusBarStyle("dark"), []);

  return <div className="QuizView">{children}</div>;
}

QuizView.Header = QuizViewHeader;
QuizView.HeaderGroup = QuizViewHeaderGroup;
QuizView.Menu = QuizViewMenu;
QuizView.Body = QuizViewBody;
QuizView.Footer = QuizViewFooter;
QuizView.Question = QuizViewQuestion;
QuizView.Messages = QuizViewMessages;
